import { gql } from "graphql-request"

const cardano = {
    name: 'cardano',
    title: 'Cardano',
    currency: 'ADA',
    check: true,
    regexp: '([\\W]|^)((addr1)[2-49a-zA-Z][0-9a-zA-Z]{50,98})([\\W]|$)',
    noregxp: ['([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)'],
    query: gql`query ($address: String!) {
        cardano(network: cardano) {
            addressStats(address:{is:$address}){
                address{
                    balance:balance
                    balance_usd: balance(in: USD)
                }
            }
            ins: inputs(currency: {is: "ADA"}, inputAddress: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: outputs(currency: {is: "ADA"}, outputAddress: {is: $address}) {
                count: count(uniq: transactions)
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }`,
    checkAddress:
        'addr1q8cdgkjxx2vzceel7rk34ny24sf9dt6dn07qacqtcjdfp5t90tapt6zxgvyqrrp5g4xz40qkv32yfzel9uqayr0555xslchjlj',
}
export { cardano }
